import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Avatar as Avatar$1 } from '../Avatar/Avatar.es.js';

const Avatar = styled(Avatar$1)``;
const avatarWrapperMask = variant({
  prop: "size",
  variants: {
    sm: {
      maskImage: "radial-gradient(ellipse 120px 100px at -20px center, #0000 30px, #000 30.5px)"
    },
    md: {
      maskImage: "radial-gradient(ellipse 120px 110px at -20px center, #0000 30px, #000 30.5px)"
    },
    lg: {
      maskImage: "radial-gradient(ellipse 120px 130px at -20px center, #0000 30px, #000 30.5px)"
    }
  }
});
const AvatarWrapper = styled(Box)`
    display: flex;
    align-items: center;
    flex-direction: row;
    position: relative;

    &:hover:not(:disabled) {
        text-decoration: none;
    }

    &:not(:first-child) {
        margin-left: -7px;

        ${Avatar} {
            ${avatarWrapperMask};
        }
    }

    &:hover {
        z-index: 100;

        ${Avatar} {
            mask-image: initial;
        }
    }
`;

export { Avatar, AvatarWrapper };
//# sourceMappingURL=styled.es.js.map
